import React, { useEffect, useState, useRef } from 'react';
import './statistics_theme.css';

const Statistics = ({ matchId, language = 'en', isDesktop = true }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const widgetRef = useRef(null);

  useEffect(() => {
    if (!matchId || matchId === '0') return;

    // Load the SIR script if not already loaded
    if (!window.SIR) {
      const script = document.createElement('script');
      script.src = 'https://trackerv2.yextof.com/widgetloader.php';
      script.async = true;
      script.setAttribute('n', 'SIR');
      document.body.appendChild(script);

      script.onload = () => {
        initializeWidget();
      };

      script.onerror = () => {
        setError('Failed to load statistics widget');
        setLoading(false);
      };
    } else {
      initializeWidget();
    }

    function initializeWidget() {
      try {
        if (window.SIR) {
          // Set global SIR configuration for statistics
          window.SIR.o = {
            theme: false, // Disable default theme to use custom CSS
            language: language
          };

          // Initialize the statistics widget
          window.SIR('addWidget', '.sr-statistics-widget', 'match.generalStatistics', {
            matchId: matchId,
            disableWidgetHeader: true,
            disableMatchHeader: true,
            disableCharts: true,
            chartType: "bullet",
            layout: "compact",
            language: language
          });

          setLoading(false);
        }
      } catch (err) {
        console.error('Error initializing statistics widget:', err);
        setError('Failed to initialize statistics widget');
        setLoading(false);
      }
    }

    return () => {
      // Cleanup function if needed
    };
  }, [matchId, language]);

  if (!matchId || matchId === '0') {
    return (
      <div className="statistics-container">
        <div className="statistics-error">
          <p>No match ID provided for statistics</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="statistics-container">
        <div className="statistics-error">
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="statistics-container">
      <style>
        {`
          .statistics-container {
            max-width: 620px;
            width: 100%;
            margin: 0 auto;
            background: #000;
            color: #fff;
            min-height: 400px;
          }
          .sr-statistics-widget {
            border: rgba(255,255,255,0.1) solid 1px;
            border-radius: 8px;
            background: #000;
          }
          .statistics-loading {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 200px;
            color: #fff;
            font-size: 16px;
          }
          .statistics-error {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 200px;
            color: #ff4444;
            font-size: 16px;
            text-align: center;
            padding: 20px;
          }
          .statistics-desktop {
            min-height: 500px;
          }
          .d-none {
            display: none;
          }
        `}
      </style>

      {loading && (
        <div className="statistics-loading">
          Loading statistics...
        </div>
      )}
      
      <div
        className={`sr-statistics-widget ${loading ? 'd-none' : ''} ${isDesktop ? 'statistics-desktop' : ''}`}
        ref={widgetRef}
      />
    </div>
  );
};

export default Statistics;
